import * as React from 'react';
import { Provider } from 'react-redux';
import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitRoot } from '@cian/ui-kit';

import { TReduxStore } from '../../types/redux';
import { ApplicationContext } from '../ApplicationContext';
import { IApplicationContext } from '../../types/applicationContext';
import { DocumentContainer } from '../Document';
import { TDevice } from '@cian/utils';

export interface IApplicationProps extends IApplicationContext {
  reduxStore: TReduxStore;
  deviceType?: TDevice;
}

export const Application: React.FC<IApplicationProps> = ({ reduxStore, deviceType, ...context }) => {
  const initialDeviceType = deviceType || (context.config.get<TDevice>('initialDeviceType') as TDevice);

  return (
    <ApplicationContext.Provider value={context}>
      <UiKitRoot deviceType={initialDeviceType}>
        <ErrorLogComponent logger={context.logger}>
          <Provider store={reduxStore}>
            <DocumentContainer />
          </Provider>
        </ErrorLogComponent>
      </UiKitRoot>
    </ApplicationContext.Provider>
  );
};
